import React, { useState } from 'react'
import { useWithAuth } from '../../containers/App'
import styled from 'styled-components'
import { useMutation } from 'react-query'
import { navigate } from 'gatsby'
import { useNotifications } from '../../containers/Notifications'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Layout from '../../components/Layout'
import colors from '../../styles/colors'

import { ActiveQuestionHeader } from './utils'

// @ts-ignore @todo add apprioprate declaration file
import addIcon from '../../images/addIcon.svg'

//const endpoint = '/report/rest/examination'

function AddSurvey() {
  const [survey, setSurvey] = useState({
    title: '',
    description: '',
  })
  const endpoint = '/form/rest/survey/header'
  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const [mutate] = useMutation<any, ActiveQuestionHeader>((values) =>
    withAuth(endpoint, {
      method: 'POST',
      payload: values,
    })
      .then((res) => {
        if ('fieldErrors' in res) {
          // @todo notifications
        } else {
          notify('Dodano ankietę', 'success')
          navigate(`/app/surveys/${res.id}`)
        }
      })
      .catch((e) => {
        e.status === 403 && notify(' brak wymaganych uprawnień', 'error')
      })
  )

  return (
    <Layout>
      <Heading title="Ankiety">
        <Button
          link={null}
          onClick={() => mutate(survey)}
          label="Zapisz"
          icon={addIcon}
          width="auto"
          altTag=""
          srText=""
        />
      </Heading>
      <SurveyWrapper>
        <h2>Tytuł ankiety</h2>
        <Input
          aria-label="Tytuł ankiety"
          name="Tytuł ankiety"
          maxLength={100}
          onChange={(element) =>
            setSurvey({ ...survey, title: element.target.value })
          }
        />
        <label htmlFor="Opis-ankiety">Opis</label>
        <Input
          name="Opis-ankiety"
          aria-label="Opis"
          id="Opis-ankiety"
          maxLength={200}
          onChange={(element) =>
            setSurvey({ ...survey, description: element.target.value })
          }
        />
      </SurveyWrapper>
    </Layout>
  )
}

export default AddSurvey

const SurveyWrapper = styled.div`
  margin: 3vh 20vw 0px 20vw;
  display: flex;
  flex-flow: column;
`
const Input = styled.input`
  min-width: 97.5%;
  margin: 5px 0;
  border: ${(props) =>
    props.selected
      ? `1px solid ${colors.monza}`
      : `1px solid ${colors.light_black}`};
  font-size: 14px;
  font-weight: 100;
  padding: 10px 15px;
  border-radius: 4px;
  height: 46px;
  box-sizing: border-box;
  &:disabled {
    background: #ebebe4;
  }
  &:focus {
    outline: 2px solid ${colors.monza};
    box-shadow: 0 0 0 1px ${colors.monza};
  }
`
